// extracted by mini-css-extract-plugin
export var wrap = "FormBanner-module--wrap--3fYrl";
export var banner = "FormBanner-module--banner--2fxLu";
export var light = "FormBanner-module--light--FZgq7";
export var dark = "FormBanner-module--dark--1lfU4";